import type { Block } from 'blockly/core';

import { arduinoGenerator, Order } from './arduino-generator.js';

/**
 * Generators for Beginner Math blocks (Convert Range, Limit Value).
 * Number / arithmetic / random use the shared standard generators.
 */
export function registerBeginnerMathGenerators(): void {
  arduinoGenerator.forBlock['beginner_math_convert_range'] = (block: Block) => {
    const value = arduinoGenerator.valueToCode(block, 'VALUE', Order.NONE) || '0';
    const fromLow = arduinoGenerator.valueToCode(block, 'FROM_LOW', Order.NONE) || '0';
    const fromHigh = arduinoGenerator.valueToCode(block, 'FROM_HIGH', Order.NONE) || '1023';
    const toLow = arduinoGenerator.valueToCode(block, 'TO_LOW', Order.NONE) || '0';
    const toHigh = arduinoGenerator.valueToCode(block, 'TO_HIGH', Order.NONE) || '255';
    return [
      `map(${value}, ${fromLow}, ${fromHigh}, ${toLow}, ${toHigh})`,
      Order.FUNCTION_CALL,
    ];
  };

  arduinoGenerator.forBlock['beginner_math_limit_value'] = (block: Block) => {
    const value = arduinoGenerator.valueToCode(block, 'VALUE', Order.NONE) || '0';
    const low = arduinoGenerator.valueToCode(block, 'LOW', Order.NONE) || '0';
    const high = arduinoGenerator.valueToCode(block, 'HIGH', Order.NONE) || '100';
    return [`constrain(${value}, ${low}, ${high})`, Order.FUNCTION_CALL];
  };
}

registerBeginnerMathGenerators();
